module.exports = __webpack_public_path__ + "img/share.e4a705e4.svg";